import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const CorporationSearchService = {
    list: async (data) => axios.post(API_URL + `/corporationSearch/passageSearchList`, data).then(({data}) => data).catch((err) => { throw err }),
    vehicleDetails: async (id) => axios.get(API_URL + `/corporationSearch/vehicleDetails/${id}`).then(({data}) => data).catch((err) => { throw err }),
    previous: async (data) => axios.post(API_URL + `/corporationSearch/previousPassage`, data).then(({data}) => data).catch((err) => { throw err }),
    next: async (data) => axios.post(API_URL + `/corporationSearch/nextPassage`, data).then(({data}) => data).catch((err) => { throw err }),
}

export default CorporationSearchService;